import { createUseStyles } from 'react-jss'
import { colors, boxShadows } from '../../variables.style'

const mediaPhoneSize = '@media (max-width: 460px)'

export const style = {
  cookieBanner: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    backgroundColor: colors.backgroundGray,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '15px 30px',
    boxShadow: boxShadows.splitLayoutContent
  },
  cookieMessage: {
    flex: 1,
    minWidth: 200,
    fontSize: 13
  },
  cookieButtons: {
    minWidth: 200,
    display: 'flex',
    justifyContent: 'end',
    [mediaPhoneSize]: {
      marginTop: 15,
      justifyContent: 'center'
    }
  }
}

export const useStyles = createUseStyles(style)
